// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard-line[data-v-c4213228] {\n  display: flex;\n}\n.dashboard-line .briq-input[data-v-c4213228] {\n  margin-right: 24px;\n}\n.dashboard-line .global-checkbox[data-v-c4213228] {\n  width: 250px;\n  margin-top: 27px;\n}\n.remove-button[data-v-c4213228] {\n  margin: 0 auto;\n  cursor: pointer;\n  margin-top: 20px;\n  padding: 0 10px;\n}\n", ""]);
// Exports
module.exports = exports;
